import React, {useEffect} from 'react';
import {Box, Typography, Card, CardContent} from '@mui/material';
import {ReactComponent as TagIcon} from '../../../../../assets/images/tagging.svg';
import {ReactComponent as ScopIcon} from '../../../../../assets/images/scope.svg';
import './JobTypeSelector.scss';
import {useNavigate} from 'react-router-dom';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {t} from 'i18next';
import {useDispatch} from 'react-redux';
import {
  setCloneJobName,
  setJobType,
} from '../../../../../redux/slice/aiReviewSliceV2';
import {AI_REVIEW_JOB_TYPE} from '../../constant/AiReviewConstants';
import {JobType} from '../../../../../api/types/aiReview.type';

interface JobTypeSelectorProps {
  handleJobTypeModalClose?: () => void;
}

const JobTypeSelector = ({handleJobTypeModalClose}: JobTypeSelectorProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCloneJobName(''));
  }, []);
  const jobTypes = [
    {
      id: AI_REVIEW_JOB_TYPE.relevancy,
      title: `${t('ai.review.jobType.relevancy')}`,
      description: `${t('ai.review.jobType.relevancyDescription')}`,
      icon: <ScopIcon />,
    },
    {
      id: AI_REVIEW_JOB_TYPE.issueCoding,
      title: `${t('ai.review.jobType.issueCoding')}`,
      description: `${t('ai.review.jobType.issueCodingDescription')}`,
      icon: <TagIcon />,
    },
  ];

  const handleJobClick = (job: (typeof jobTypes)[number]) => {
    dispatch(setJobType(job.id as JobType));
    navigate('/AI/Review/CreateJob');
    handleJobTypeModalClose && handleJobTypeModalClose();
  };

  return (
    <Box className="jobtype-wrapper">
      <Box className="jobtype-title-row">
        <Typography
          component="h2"
          variant="h6"
          className="typo-text headline3_size title"
          id="job-type-selector-title"
          data-testid="job-type-selector-title"
        >
          {t('ai.review.jobType.title')}
        </Typography>
        <ArrButton
          variant="secondary"
          size="medium"
          disabled={false}
          aria-label={t('ai.review.jobType.close')}
          className="close-button"
          onClick={handleJobTypeModalClose || (() => {})}
          dataTestId="job-type-selector-close-button"
        >
          {t('ai.review.jobType.close')}
        </ArrButton>
      </Box>
      <Box className="card-container">
        {jobTypes.map((job, index) => {
          const titleId = `job-type-title-${job.id}`;
          const descriptionId = `job-type-desc-${job.id}`;
          return (
            <Card
              className="job-card"
              key={job.id}
              tabIndex={0}
              role="button"
              aria-labelledby={titleId}
              aria-describedby={descriptionId}
              onClick={() => handleJobClick(job)}
              data-testid={`job-${job.id}-click`}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleJobClick(job);
                }
              }}
            >
              <CardContent className="card-content">
                <Box className="icon-wrapper" aria-hidden="true">
                  {job.icon}
                </Box>
                <Typography
                  variant="subtitle1"
                  className="typo-text subhead2_size card-title"
                  id={titleId}
                  data-testid={`job-type-selector-job-title-${index}`}
                >
                  {job.title}
                </Typography>
                <Typography
                  variant="body2"
                  className="typo-text body3_size card-desc"
                  id={descriptionId}
                  data-testid={`job-type-selector-job-description-${index}`}
                >
                  {job.description}
                </Typography>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
};

export default JobTypeSelector;
